import React, { useState } from "react";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import { useNavigate } from "react-router-dom";
import ProductSelectDialog from "./../../components/ProductSelectDialog";
import { useProductsBranch } from "./../../hooks/useProductsBranch";
import PackDialog from "./../../components/PackDialog";
import * as services from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";

const buttonsTop = [
  // {
  //   label: "แพ็คสินค้า",
  //   icon: <MoveToInboxIcon style={{ fontSize: 32 }} />,
  //   route: "",
  //   isDialog: true,
  //   color: "bg-emerald-50 text-emerald-600",
  // },
  {
    label: "การแปรสภาพสินค้า",
    icon: <LoopOutlinedIcon style={{ fontSize: 32 }} />,
    route: "transform",
    color: "bg-blue-50 text-blue-600",
  },
  {
    label: "คลังสินค้า",
    icon: <Inventory2OutlinedIcon style={{ fontSize: 32 }} />,
    route: "inventory",
    color: "bg-yellow-50 text-yellow-600",
  },
];

export default function Stock() {
  const navigate = useNavigate();
  const [openProdDialog, setOpenProdDialog] = useState(false);
  const [openPackDialog, setOpenPackDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { products } = useProductsBranch();

  const handleClick = (btn) => {
    if (btn.isDialog) setOpenProdDialog(true);
    else if (btn.external) window.open(btn.route, "_blank");
    else navigate(btn.route);
  };

  // ยิง API package (upsert)
  const handleCreateOrUpdatePackage = async (payload) => {
    const body = {
      productId: Number(payload.productId),
      type: String(payload.category || ""),
      quantity: Number(payload.net || 0),
      ...(payload?.id != null ? { id: Number(payload.id) } : {}),
    };
    return await services.upsertPackage(body);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col p-4">
      <div className="w-full max-w-[1600px] mx-auto space-y-6">
        <AppBreadcrumbs />
        <Toaster position="bottom-left" reverseOrder={false} />
        
        <div className="min-h-[60vh] flex flex-col items-center justify-center">
            <h1 className="text-2xl font-bold text-gray-700 mb-8">จัดการสต๊อกสินค้า</h1>
            
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 w-full max-w-4xl px-2 md:px-0">
              {buttonsTop.map((btn, index) => (
                <div
                  key={index}
                  onClick={() => handleClick(btn)}
                  className="w-[calc(50%-0.5rem)] md:w-[calc(33.333%-1rem)] bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 hover:shadow-lg hover:border-blue-200 hover:-translate-y-1 group"
                >
                  <div className={`w-20 h-20 rounded-2xl ${btn.color || 'bg-gray-50 text-gray-600'} flex items-center justify-center mb-5 transition-transform group-hover:scale-110 shadow-inner`}>
                    {btn.icon}
                  </div>
                  <span className="text-lg text-gray-700 font-bold text-center whitespace-pre-line group-hover:text-blue-600 transition-colors">
                    {btn.label}
                  </span>
                </div>
              ))}
            </div>
        </div>

        {/* เลือกสินค้า */}
        <ProductSelectDialog
          open={openProdDialog}
          onClose={() => {
            setOpenProdDialog(false);
          }}
          products={products}
          disabledProductIds={[]}
          onConfirm={(prod) => {
             // Logic adaptation: ProductSelectDialog returns 'prod' onConfirm
             // But original code passed `onSelect`.
             // New ProductSelectDialog prop is `onConfirm`.
             setSelectedProduct(prod);
             setOpenPackDialog(true);
          }}
        />

        {/* Dialog แพ็คสินค้า */}
        <PackDialog
          open={openPackDialog}
          onClose={() => setOpenPackDialog(false)}
          product={selectedProduct}
          onConfirm={async (payload) => {
            try {
              const res = await handleCreateOrUpdatePackage(payload);
              console.log("Package saved:", res?.data);
              setOpenProdDialog(false);
              setOpenPackDialog(false);
              toast.success("บันทึก Package สำเร็จ");
            } catch (err) {
              console.error("save package error:", err);
              toast.error("บันทึก Package ไม่สำเร็จ");
            }
          }}
        />
      </div>
    </div>
  );
}
